module.exports = __webpack_public_path__ + "static/media/FTLLogo.68ba8aab.svg";